<ng-container *ngFor="let group of groupLabels; let i = index">
  <ng-container *ngIf="getGroupsField(group.label).length > 0">
    <fieldset class="border border-secondary rounded p-3 mb-2">
      <legend class="float-none w-auto px-2 text-secondary fs-6">
        {{ group.label }}
      </legend>
      <div class="row">
        <ng-container
          *ngFor="let field of getGroupsField(group.label); let i = index"
        >
          <ng-container *ngIf="getAttributeById(field.id) as e">
            <ng-container *ngIf="e['type'] == 'textarea'">
              <div class="col-{{ getDefaultColums(field) }} textarea-container">
                <label
                  for="title"
                  class="form-label mt-2"
                  *ngIf="e['type'] !== 'file'"
                  >{{ e.label }}
                  <span *ngIf="e['required'] == 1">*</span>
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <textarea
                    matInput
                    [rows]="field['rows']"
                    [cols]="field['cols']"
                    [name]="e.code"
                    [placeholder]="e.label"
                  >
                  </textarea>
                </mat-form-field>
              </div>
            </ng-container>

            <ng-container *ngIf="e['type'] !== 'textarea'">
              <div class="col-{{ getColums(field) }} ">
                <label
                  for="title"
                  class="form-label mt-2"
                  *ngIf="e['type'] !== 'file'"
                  >{{ e.label }}
                  <span *ngIf="e['required'] == 1">*</span>
                </label>
                <ng-container
                  *ngIf="
                    e['refKey'] != 1 &&
                    e['type'] !== 'list' &&
                    e['type'] !== 'file' &&
                    e['type'] !== 'map' &&
                    e['type'] !== 'date' &&
                    e['type'] !== 'idate' &&
                    e['type'] !== 'time' &&
                    e['type'] !== 'itime' &&
                    e['type'] !== 'dateandtime'
                  "
                >
                  <mat-form-field class="w-100" appearance="outline">
                    <input
                      matInput
                      [type]="getInputType(e.type)"
                      [name]="e.code"
                      [placeholder]="e.label"
                    />
                  </mat-form-field>
                </ng-container>

                <ng-container *ngIf="e.type === 'date' || e.type === 'idate'">
                  <mat-form-field class="w-100" appearance="outline">
                    <input
                      matInput
                      type="date"
                      [name]="e.code"
                      [placeholder]="e.label"
                      #dateInput
                    />

                    <button
                      mat-icon-button
                      matSuffix
                      class="icon-pd-none"
                      type="button"
                      (click)="dateInput.showPicker()"
                    >
                      <mat-icon class="icon-compact text-secondary"
                        >event</mat-icon
                      >
                    </button>
                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="e.type === 'time' || e.type === 'itime'">
                  <mat-form-field class="w-100" appearance="outline">
                    <input
                      matInput
                      type="time"
                      [name]="e.code"
                      [placeholder]="e.label"
                      #timeInput
                    />

                    <button
                      mat-icon-button
                      matSuffix
                      class="icon-pd-none"
                      type="button"
                      (click)="timeInput.showPicker()"
                    >
                      <mat-icon class="icon-compact text-secondary"
                        >schedule</mat-icon
                      >
                    </button>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngIf="e.type === 'dateandtime'">
                  <mat-form-field class="w-100" appearance="outline">
                    <input
                      matInput
                      type="datetime-local"
                      [name]="e.code"
                      [placeholder]="e.label"
                      #datetimeInput
                    />

                    <button
                      mat-icon-button
                      matSuffix
                      class="icon-pd-none"
                      type="button"
                      (click)="datetimeInput.showPicker()"
                    >
                      <mat-icon class="icon-compact text-secondary"
                        >event</mat-icon
                      >
                    </button>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngIf="e['refKey'] == 1" class="mb-2">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>{{ e.label }}</mat-label>
                    <mat-select [required]="e['required'] == 1">
                      <mat-option value="0">--Select-- {{ e.code }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngIf="e['type'] === 'list'" class="mb-2">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-select
                      [required]="e['required'] == 1"
                      placeholder="--Select-- {{ e.code }}"
                    >
                      <mat-option value="0">--Select-- {{ e.code }}</mat-option>
                      <mat-option *ngFor="let c of e['values']" [value]="c">{{
                        c
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>

                <!-- Image File  -->
                <ng-container *ngIf="e['type'] === 'file'" class="mb-2">
                  <mat-form-field
                    class="w-100 icon-compact"
                    appearance="outline"
                  >
                    <input
                      matInput
                      #file
                      type="file"
                      accept="image/*"
                      [name]="e.code"
                    />
                    <mat-icon class="icon-compact text-secondary" matSuffix
                      >attach_file</mat-icon
                    >
                  </mat-form-field>
                </ng-container>

                <!-- DropDown List  -->
                <ng-container *ngIf="e['type'] === 'map'" class="mb-2">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-select
                      [required]="e['required'] == 1"
                      placeholder="--Select-- {{ e.code }}"
                    >
                      <mat-option value="0">--Select-- {{ e.code }}</mat-option>
                      <mat-option *ngFor="let c of e['values']" [value]="c.key">
                        {{ c.value }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </fieldset>
  </ng-container>
</ng-container>
<div class="row compact-inputs">
  <ng-container *ngFor="let field of getFieldNotIngroup(); let i = index">
    <ng-container *ngIf="getAttributeById(field.id) as e">
      <ng-container *ngIf="e['type'] == 'textarea'">
        <div class="col-{{ getDefaultColums(field) }} ">
          <label
            for="title"
            class="form-label mt-2"
            *ngIf="e['type'] !== 'file'"
            >{{ e.label }}
            <span *ngIf="e['required'] == 1">*</span>
          </label>

          <mat-form-field class="w-100" appearance="outline">
            <textarea
              matInput
              [rows]="field['rows']"
              [cols]="field['cols']"
              [name]="e.code"
              [placeholder]="e.label"
            >
            </textarea>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngIf="e['type'] !== 'textarea'">
        <div class="col-{{ getColums(field) }} ">
          <label for="title" class="form-label mt-2 mb-0"
            >{{ e.label }}
            <span *ngIf="e['required'] == 1">*</span>
          </label>
          <ng-container
            *ngIf="
              e['refKey'] != 1 &&
              e['type'] !== 'list' &&
              e['type'] !== 'file' &&
              e['type'] !== 'map' &&
              e['type'] !== 'date' &&
              e['type'] !== 'idate' &&
              e['type'] !== 'time' &&
              e['type'] !== 'itime' &&
              e['type'] !== 'dateandtime'
            "
          >
            <mat-form-field class="w-100" appearance="outline">
              <input
                matInput
                [type]="getInputType(e.type)"
                [name]="e.code"
                [placeholder]="e.label"
              />
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="e.type === 'date' || e.type === 'idate'">
            <mat-form-field class="w-100" appearance="outline">
              <input
                matInput
                type="date"
                [name]="e.code"
                [placeholder]="e.label"
                #dateInput
              />

              <button
                mat-icon-button
                matSuffix
                class="icon-pd-none"
                type="button"
                (click)="dateInput.showPicker()"
              >
                <mat-icon class="icon-compact text-secondary">event</mat-icon>
              </button>
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="e.type === 'time' || e.type === 'itime'">
            <mat-form-field class="w-100" appearance="outline">
              <input
                matInput
                type="time"
                [name]="e.code"
                [placeholder]="e.label"
                #timeInput
              />

              <button
                mat-icon-button
                matSuffix
                class="icon-pd-none"
                type="button"
                (click)="timeInput.showPicker()"
              >
                <mat-icon class="icon-compact text-secondary"
                  >schedule</mat-icon
                >
              </button>
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="e.type === 'dateandtime'">
            <mat-form-field class="w-100" appearance="outline">
              <input
                matInput
                type="datetime-local"
                [name]="e.code"
                [placeholder]="e.label"
                #datetimeInput
              />

              <button
                mat-icon-button
                matSuffix
                class="icon-pd-none"
                type="button"
                (click)="datetimeInput.showPicker()"
              >
                <mat-icon class="icon-compact text-secondary">event</mat-icon>
              </button>
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="e['refKey'] == 1" class="mb-2">
            <mat-form-field class="w-100" appearance="outline">
              <mat-select
                [required]="e['required'] == 1"
                placeholder="--Select-- {{ e.code }}"
              >
                <mat-option value="0">--Select-- {{ e.code }}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="e['type'] === 'list'" class="mb-2">
            <mat-form-field class="w-100" appearance="outline">
              <mat-select
                [required]="e['required'] == 1"
                placeholder="--Select-- {{ e.code }}"
              >
                <mat-option value="0">--Select-- {{ e.code }}</mat-option>
                <mat-option *ngFor="let c of e['values']" [value]="c">{{
                  c
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <!-- Image File  -->
          <ng-container *ngIf="e['type'] === 'file'">
            <input
              class="form-control mb-3"
              #file
              type="file"
              accept="image/*"
              name="form.data[e.code]"
            />
          </ng-container>

          <!-- DropDown List  -->
          <ng-container *ngIf="e['type'] === 'map'" class="mb-2">
            <mat-form-field class="w-100" appearance="outline">
              <mat-select [required]="e['required'] == 1" [id]="e.code">
                <mat-option value="0">--Select-- {{ e.code }}</mat-option>
                <mat-option *ngFor="let c of e['values']" [value]="c.key">
                  {{ c.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<div class="row mt-4">
  <div class="col-auto">
    <div class="d-flex flex-wrap gap-2">
      <button
        *ngFor="let btn of buttons; let i = index"
        mat-stroked-button
        type="button"
        [color]="getMaterialColor(btn['name'])"
      >
        <mat-icon class="icon-compact">{{
          getMaterialIcon(btn["name"])
        }}</mat-icon>
        {{ getButtonLabel(btn["name"]) }}
      </button>
    </div>
  </div>
</div>
